angular.module('ikeweb.spike.gallery').controller('GalleryController', [
    '$scope',
    'spikeCaptureService',
    'SpikeUtil',
    'events',
    'confirmationService',
    '$translate',
    'billingService',
    'notificationService',
    function($scope, $spikeCaptureService, SpikeUtil, EVENTS, confirmationService, $translate, billingService, notificationService) {
        var currentFolder;
        $scope.shownCaptures = [];

        var loadingCaptures = true;

        function inFolder(capture) {
            return capture.isInFolder(currentFolder);
        }

        function filterCapturesInCurrentFolder() {
            $scope.shownCaptures = $scope.shownCaptures.filter(inFolder);
        }

        function refreshCaptureList() {
            loadingCaptures = true;

            var folderId = currentFolder == null ? null : currentFolder.getId();

            return $spikeCaptureService.listCaptures(folderId)
                .then(function(captures) {
                    $scope.shownCaptures = captures;
                    loadingCaptures = false;
                });
        }

        billingService.isOnPremium().then(function(isPro) {
            $scope.isPro = isPro;
        });

        $scope.isLoadingCaptures = function() {
            return loadingCaptures;
        };

        function filterByProperty(by, value) {
            return function(object) {
                return value ? object[by] === value : object[by];
            };
        }

        $scope.refresh = function() {
            refreshCaptureList();
        };

        $scope.selectAll = function() {
            $scope.shownCaptures.forEach(function(capture) {
                capture.$selected = true;
            });
        };

        $scope.deselectAll = function() {
            $scope.shownCaptures.forEach(function(capture) {
                capture.$selected = false;
            });
        };

        $scope.deleteSelectedCaptures = function() {
            var capturesToDelete = $scope.shownCaptures.filter(filterByProperty('$selected'));
            if (capturesToDelete.length === 0) {
                return;
            }

            confirmationService
                .confirm($translate.instant('NOTIFICATION.CAPTURE.DELETE_CAPTURE_TITLE'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRMATION'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRM'),
                    $translate.instant('NOTIFICATION.DELETE.CANCEL'))
                .then(function() {
                    $spikeCaptureService.deleteCaptures(capturesToDelete)
                        .then(refreshCaptureList);
                });
        };

        $scope.isEmpty = function() {
            return $scope.shownCaptures.length === 0;
        };

        $scope.$on(EVENTS.FOLDER.SELECTED, function(event, folder) {
            currentFolder = folder;
            $scope.shownCaptures = [];
            refreshCaptureList();
        });

        $scope.$on(EVENTS.FOLDER.CAPTURE.DROPPED, function(evt, data) {
            var targetCaptures = $scope.shownCaptures.filter(filterByProperty('$selected'));
            if (!$scope.isPro && targetCaptures.length > 0) {
                targetCaptures = [];
                notificationService.info('NOTIFICATION.CAPTURE.MULTISELECT_IS_PRO_TITLE', 'NOTIFICATION.CAPTURE.MULTISELECT_IS_PRO')();
            }

            if (targetCaptures.length === 0) {
                targetCaptures.push(data.capture);
            }

            $spikeCaptureService.putCapturesInFolder(targetCaptures, data.folder)
                .then(filterCapturesInCurrentFolder);
        });
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/gallery/gallery.controller.js
// module id = 523
// module chunks = 0